import { useEffect } from "react";
import { useNotificationStore } from "./stores";
import { BATCH_BONUS_UPDATED_EVENT } from "../../api/batchBonusApi";

export interface BatchBonusMailBadge {
  /** 未读的"批量赠金"站内信条数（type=BATCHBONUS_ACTIVITY 且未读） */
  count: number;
  /** 最近一条未读批量赠金站内信的图标（原始 resourceId，可空） */
  icon: string | null;
}

/**
 * 批量赠金邮件角标状态（F31）。
 * 数据完全复用消息中心的 syncUserNotices（首页已加载的 /api/user/notice_page），
 * 在 store 里从站内信列表统计得出，**不再单独请求接口**（避免首页多打一个请求）。
 * 有未读批量赠金站内信时：邮件图标切换为该通知图标、角标显示其条数（优先于普通未读数）。
 * 领取后（BATCH_BONUS_UPDATED_EVENT）重新同步站内信列表以刷新。
 */
export function useBatchBonusMailBadge(): BatchBonusMailBadge {
  const count = useNotificationStore(s => s.batchBonusUnreadCount);
  const icon = useNotificationStore(s => s.batchBonusIcon);
  const syncUserNotices = useNotificationStore(s => s.syncUserNotices);

  useEffect(() => {
    const onUpdated = () => {
      void syncUserNotices();
    };
    window.addEventListener(BATCH_BONUS_UPDATED_EVENT, onUpdated);
    return () => {
      window.removeEventListener(BATCH_BONUS_UPDATED_EVENT, onUpdated);
    };
  }, [syncUserNotices]);

  return { count, icon };
}
